/*ěščřžýáíéúů*/
// Swiper initialization and tag filtering
document.addEventListener("DOMContentLoaded", function () {
    const aktualitySection = document.querySelector("#teach");

    if (aktualitySection) {
        const tags = aktualitySection.querySelectorAll(".tag[data-category]");
        const swiperSlides = aktualitySection.querySelectorAll(".swiper-slide[data-categories]");
        const swiperInstance = aktualitySection.querySelector(".another-teach__slider-swiper");

        let swiper = null;

        // Inicializace Swiper instance
        function initSwiper() {
            if (window.Swiper && swiperInstance) {
                console.log("Initializing Swiper for rozcestnik-kategorie-skoleni");
                swiper = new Swiper(swiperInstance, {
                    slidesPerView: "auto",
                    spaceBetween: 16,
                    freeMode: true,
                    navigation: {
                        nextEl: ".buttons-teach__next",
                        prevEl: ".buttons-teach__prev",
                    },
                    breakpoints: {
                        768: {
                            spaceBetween: 24,
                        },
                    },
                });
                console.log("Swiper initialized successfully");
            } else {
                console.log("Swiper not available or swiperInstance not found");
            }
        }

        // Inicializace Swiper (vždy, ne pouze když jsou tagy)
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", initSwiper);
        } else {
            initSwiper();
        }

        // Fallback pro případ, že Swiper ještě není dostupný
        setTimeout(initSwiper, 100);

        // Filtrování pouze pokud existují tagy a slides
        if (tags.length > 0 && swiperSlides.length > 0) {
            // Funkce pro filtrování článků podle kategorie
            function filterArticles(selectedCategory) {
                swiperSlides.forEach((slide) => {
                    const slideCategories = slide.getAttribute("data-categories");

                    if (selectedCategory === "all" || (slideCategories && slideCategories.split(",").includes(selectedCategory))) {
                        slide.style.display = "block";
                    } else {
                        slide.style.display = "none";
                    }
                });

                // Refresh Swiper po filtrování
                if (swiper) {
                    swiper.update();
                    swiper.slideTo(0);
                }
            }

            // Event listenery pro tagy
            tags.forEach((tag) => {
                tag.addEventListener("click", function () {
                    const selectedCategory = this.getAttribute("data-category");

                    // Odstranění active třídy ze všech tagů
                    tags.forEach((t) => t.classList.remove("active"));

                    // Přidání active třídy k vybraném tagu
                    this.classList.add("active");

                    // Filtrování článků
                    filterArticles(selectedCategory);
                });
            });
        }
    }
});
